import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";
import auth from "./auth/reducer"
import projects from "./projects/reducer"


const rootReducer = combineReducers({
    Layout,
    auth,
    projects,
});

export default rootReducer;
